var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-modal",
    {
      staticClass: "parcel-prediction-modal",
      attrs: { title: "Voorspellingen", padding: false },
      on: { close: _vm.cancel },
    },
    [
      _c(
        "ui-view-panel",
        [
          _vm.forecast
            ? [
                _c("div", { staticClass: "parcel-prediction-wrapper" }, [
                  _c("div", { staticClass: "parcel-prediction" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("3 maanden:"),
                    ]),
                    _c("ul", { staticClass: "list" }, [
                      _c("li", { staticClass: "list-item" }, [
                        _vm._v(
                          "Verwachte groei: " +
                            _vm._s(
                              _vm.forecast["three_months"]["expected_growth"]
                            ) +
                            " gram"
                        ),
                      ]),
                      _c("li", { staticClass: "list-item" }, [
                        _vm._v(
                          "Foutenmarge: " +
                            _vm._s(
                              _vm.forecast["three_months"]["error_margin"]
                            ) +
                            " gram"
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "parcel-prediction" }, [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("6 maanden:"),
                    ]),
                    _c("ul", { staticClass: "list" }, [
                      _c("li", { staticClass: "list-item" }, [
                        _vm._v(
                          "Verwachte groei: " +
                            _vm._s(
                              _vm.forecast["six_months"]["expected_growth"]
                            ) +
                            " gram"
                        ),
                      ]),
                      _c("li", { staticClass: "list-item" }, [
                        _vm._v(
                          "Foutenmarge: " +
                            _vm._s(_vm.forecast["six_months"]["error_margin"]) +
                            " gram"
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "parcel-prediction" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("1 jaar:")]),
                    _c("ul", { staticClass: "list" }, [
                      _c("li", { staticClass: "list-item" }, [
                        _vm._v(
                          "Verwachte groei: " +
                            _vm._s(
                              _vm.forecast["one_year"]["expected_growth"]
                            ) +
                            " gram"
                        ),
                      ]),
                      _c("li", { staticClass: "list-item" }, [
                        _vm._v(
                          "Foutenmarge: " +
                            _vm._s(_vm.forecast["one_year"]["error_margin"]) +
                            " gram"
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }